import { ForwardedRef, forwardRef, ReactElement } from 'react';
import { IconAlertTriangle, IconInfoCircle, IconX } from '@tabler/icons-react';
import { cn } from '../../lib/utils';
import { tagVariants } from './variants';
import type { TagProps, IconTagVariant } from './types';

const tagIcons: Record<IconTagVariant, ReactElement> = {
  hint: <IconInfoCircle size={20} className='eye:text-blue-150' />,
  warning: <IconAlertTriangle size={20} className='eye:text-olive-100' />,
  error: <IconX size={20} className='eye:text-red-100' />,
};

export const Tag = forwardRef(function (
  { className, variant, children, ...props }: TagProps,
  ref: ForwardedRef<HTMLDivElement>,
) {
  return (
    <div
      ref={ref}
      className={cn('eye:tag', tagVariants({ variant }), className)}
      {...props}
    >
      {tagIcons[variant as IconTagVariant]}
      {children}
    </div>
  );
});

Tag.displayName = 'Tag';
